import styled from "@emotion/styled";
import React, { useState } from 'react';
import { NORTH, STORAGE_KEY } from "../constants";
import { addNumToArrayWithKey, pickFrom, valueAsArray } from "../utils";
import { MazeRow } from "./MazeRow";
import { Scrimblo } from "./MazeScrimblo";
import borderImage from './skull-border.svg';

interface MazeType {
    grid: number[][];
}
export const Maze: React.FC<MazeType> = ({ grid }) => {
    const StyledMaze = styled.div`
        width: 800px;
        height: 500px;
        margin-left: auto;
        margin-right: auto;
        position: relative;
    `

    const Popup = styled.div`
        width: 475px;
        height: 300px;
        background: white;
        position: absolute;
        font-size: 48px;
        font-family: 'Courier New', monospace;
        padding: 20px;
        top: 50px;
        left: 50px;
        border-left: 5px solid #a4a4a4;
        border-top: 5px solid #a4a4a4;
        border-right: 5px solid #e4e4e4;
        border-bottom: 5px solid #e4e4e4;
        box-shadow: 2px 2px 2px 3px rgba(0, 0, 0, .4);
    `
    //https://css-tricks.com/how-to-animate-a-svg-with-border-image/
    const WinningPopup = styled.div`
        border: 32px solid;
        width: 435px;
        padding: 16px 0 24px;
        margin: 0 auto;
        height: 245px;
        background: white;
        position: absolute;
        font-size: 48px;
        font-family: 'Courier New', monospace;
        top: 50px;
        left: 50px;
        box-shadow: 2px 2px 2px 3px rgba(0, 0, 0, .4);
        border-image: url(${borderImage}) 32 round;
    `

    const StyledButton = styled.button`
    font-size: 72px;
    font-family: 'Courier New', monospace;
    margin-left: auto;
    margin-right: auto;
    display: block;
    `
    const [redeem, setRedeem] = useState(false);
    const [success, setSuccess] = useState(false);
    const [failure, setFailure] = useState(false);

    //const winning = [2,2,2,2,2,2,1,1,1,1,1,1,1,1,1,1,2,1,1,1,1,1,1,1,1,1,1,1,2,2,2,2,2,3,3,3,3,3,3,2,2,2,1,1,1,1,1,1,1];

    const route = valueAsArray(STORAGE_KEY);
//what's this? you get a different reward each time? 
//that leaves you potentially unable to know when you've gotten everything
//without collaborating with others?
//a shame
const rewards = ["http://knucklessux.com/PuzzleBox/Secrets/Wanda%20Resume.pdf","http://www.farragofiction.com/PaldemicSim/login.html?passPhrase=the_end_is_never_the_end"]
    return (
        <StyledMaze>
            {
                grid.map((row, row_index) => {
                    return <MazeRow key={row_index} row={row} row_index={row_index} />
                })
            }
            {redeem ? <Scrimblo grid={grid} route={route} setSuccess={setSuccess} setFailure={setFailure} /> :
                <Popup onClick={() => {
                    addNumToArrayWithKey(STORAGE_KEY, NORTH);
                    setRedeem(true);
                }}>
                    Redeem Zampanio LossPass™  Proof Of Engagement Tokens?
                    <StyledButton>YES</StyledButton>
                </Popup>}

            {success ? <WinningPopup onClick={() => { setRedeem(true) }}>
                You did it! It is your turn for Secrets!!!
                <StyledButton onClick={()=>{window.location.href = pickFrom(rewards)}}>YES</StyledButton>
            </WinningPopup> : null}

            {failure ? <Popup onClick={() => { setRedeem(true) }}>
                Too bad!!! Try again later after playing more Zampanio!!!
            </Popup> : null}


        </StyledMaze>
    )



}